import { ShoppingCart } from '../../../components/ShoppingCart/ShoppingCart.js';
import { useSessionData } from '../SessionDataProvider.js';
import type { JSX } from 'react';

interface ShoppingCartProps {
  header?: JSX.Element;
}

export const ShoppingCartPath = ({ header }: ShoppingCartProps) => {
  const companyInfo = useSessionData().companyInfo;

  return (
    <div id="shoppingcart">
      {header}
      <ShoppingCart companyInfo={companyInfo} />
    </div>
  );
};
